import { render, staticRenderFns } from "./LicencesDevices.vue?vue&type=template&id=ce238450&scoped=true"
import script from "./LicencesDevices.vue?vue&type=script&lang=js"
export * from "./LicencesDevices.vue?vue&type=script&lang=js"
import style0 from "./LicencesDevices.vue?vue&type=style&index=0&id=ce238450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce238450",
  null
  
)

export default component.exports